import { DeviceSecurityMode } from "@src/types/device-security-mode";
import { DeviceSecurityPolicy } from "@src/types/device-security-policy";

const buildEmptyObject = (dsn) => {
  return {
    clientId: "",
    connectivityInput: dsn,
    securityModeInput: DeviceSecurityMode.NONE,
    securityPolicyInput: DeviceSecurityPolicy.NONE,
    username: "",
    password: "",
    clientCertificateBase64: "",
    clientCertificatePassword: "",
    clientCertificatePrivateKeyBase64: "",
    server_public_key_base64: "",
  };
};

const buildValueObject = (clientId, auth_info, dsn) => {
  return {
    clientId: clientId,
    connectivityInput: dsn,

    securityModeInput: auth_info.security_mode
      ? auth_info.security_mode
      : DeviceSecurityMode.NONE,

    securityPolicyInput: auth_info.security_policy
      ? auth_info.security_policy
      : DeviceSecurityPolicy.NONE,

    username: auth_info.username ? auth_info.username : "",

    password: auth_info.password ? auth_info.password : "",

    clientCertificateBase64: auth_info.client_certificate_base64
      ? auth_info.client_certificate_base64
      : "",

    clientCertificatePassword: auth_info.client_certificate_password
      ? auth_info.client_certificate_password
      : "",

    clientCertificatePrivateKeyBase64:
      auth_info.client_certificate_private_key_base64
        ? auth_info.client_certificate_private_key_base64
        : "",

    server_public_key_base64: auth_info.server_public_key_base64
      ? auth_info.server_public_key_base64
      : "",
  };
};

// TODO: test this; if there is no auth_info then this crashes
export const buildInputContentsObject = (clientId, connectionViewState) => {
  const { dsn } = connectionViewState.source;

  if (connectionViewState.source.auth_info) {
    return buildValueObject(
      clientId,
      connectionViewState.source.auth_info,
      dsn,
    );
  }

  return buildEmptyObject(dsn);
};
